<div class="border-2 border-grey-900 rounded-lg p-3 md:p-4">
  <div class="flex flex-col">
    <div class="flex justify-between">
      <div class="flex flex-col">
        <h2 class="">{{Campaign.Campaign.RequestName}}</h2>
        <div class="flex">
          <h3>{{Campaign.Campaign.PublicAuditName}}</h3>
          <h3 class="ml-1 text-grey-900">&#64; {{Campaign.Campaign.LocationName}}</h3>
        </div>
      </div>
      <div>
        @if (Campaign.Campaign.TotalMaxScore>0) {
          <div class="md:mr-8">
                <app-progress-bar [MaxScore]="Campaign.Campaign.TotalMaxScore" [Score]="Campaign.Campaign.TotalScore"></app-progress-bar>
       
          </div>
         }
        </div>
      </div>
      <div class="w-full border-b-[1px] border-grey-500 mb-2 mt-3 ml-2 mx-6">

      </div>
      <div class="flex mx-6" [ngClass]="{'justify-between':Campaign.Campaign.TotalMaxScore>0}">
        <div>
          @if (!Campaign.Campaign.Anonymous) {
            <div>
              <div>
                <h3>{{Campaign.Campaign.Participants[0].ParticipantName}}</h3>
                <h4>{{Campaign.Campaign.Participants[0].Reference}}</h4>
                <h4>{{Campaign.Campaign.Participants[0].Email}}</h4>
              </div>
            </div>
          }
          @if (Campaign.Campaign.Anonymous || Campaign.Campaign.Participants[0].ParticipantName.length == 0) {
            <div
              class="mx-4">
              <h3>Anonymous Recipient</h3>
            </div>
          }
        </div>

        @if (Campaign.Campaign.TotalMaxScore>0) {
          <div class="">
            <p class="font-bold text-lg">{{Campaign.Campaign.TotalScore}}/{{Campaign.Campaign.TotalMaxScore}}</p>
          </div>
        }
      </div>

      <div class="w-full border-b-[1px] border-grey-500 mb-2 mt-3 ml-2 mx-6">

      </div>
      @for (q of Campaign.Campaign.Participants[0].CampaignQuestions; track q) {
        <div class="p-2 mx-6 border-b-[1px] border-grey-300">
          <div class="flex justify-between items-center  pb-1">
            <div class="flex flex-col mr-2">
              <div class="flex">
                <p class="text-green-400 mr-2">Q</p>
                <p class="mr-1 font-semibold">{{q.QuestionHeader}}</p>
                <p>{{q.QuestionBody}}</p>
              </div>
              @if (!q.IsNA) {
                <div class="flex mt-1">
                  <p class="text-grey-900 mr-2">A</p>
                  <p class="mr-1">{{q.ResultText}}</p>
                </div>
              }
              @if (q.IsNA) {
                <div class="px-2 mt-1">
                  <p>Not Applicable</p>
                </div>
              }
              @if (q.Comment.length>0) {
                <div class="p-2">
                  <p class="text-grey-900 italic">{{q.Comment}}</p>
                </div>
              }
            </div>
            @if (q.MaxScore>0) {
              <div>
                <p class="font-bold">{{q.Score}}/{{q.MaxScore}}</p>
              </div>
            }
          </div>
        </div>
      }
    </div>


  </div>